import { UIComponent } from "@aptus/frontend-core";
import { A } from "components/a";
import { Trans, useTranslation } from "react-i18next";
import { RedirectSuggestion } from "utils/locales";
import styles from "./locationRedirectModal.module.css";

interface Props {
	suggestion: RedirectSuggestion;

	changeToMostRelevantSiteForLanguage: () => void;
	stayOnSite: () => void;
}

export const LocationRedirectModal: UIComponent<Props> = ({
	suggestion,
	changeToMostRelevantSiteForLanguage,
	stayOnSite,
}) => {
	const { t } = useTranslation();
	const {
		current, target, targetHost, targetLabel,
	} = suggestion;

	return (
		<div className={styles["location-redirect-modal"]} style={{ backgroundImage: "url('/locationRedirectModalBackground.png')" }}>
			<h2>{t("locationRedirect.title")}</h2>
			<p>
				<Trans i18nKey="locationRedirect.body" components={{ bold: <strong />, italic: <A target="_self" href={`https://${targetHost}`} />, br: <br /> }} values={{ site: targetLabel, emoji: target.emoji }} />
			</p>
			<div className={styles["actions-wrapper"]}>
				<button onClick={stayOnSite} type="button" className="secondary">{t("locationRedirect.stay", { emoji: current.emoji })}</button>
				<button onClick={changeToMostRelevantSiteForLanguage} type="button">{t("locationRedirect.leave", { emoji: target.emoji })}</button>
			</div>
		</div>
	);
};
